import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { useStore } from '../../app/stores/store';
import '../../app/common/MediaQuery/responsive-tables.css';
import DynamicTableFrontEnd from '../DynamicTable/DynamicTableFrontEnd';

function DeviceMasterTable() {
  const { DeviceStore, vaultStore } = useStore();
  const { loadDevices, deviceitemsByDate, loading } = DeviceStore;
  const [showText, setShow] = useState(false);
  const { vaultRegistry, loadVaults } = vaultStore;
  useEffect(() => {
    loadDevices();
  }, [loadDevices]);
  useEffect(() => {
    if (vaultRegistry.size <= 1) loadVaults();
  }, [vaultRegistry.size, loadVaults]);
  useEffect(() => {
    setShow(true);
  }, []);

  const removeCol =
    'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,itemCreatedAt,inactive,isgoing,ishost';
  const DeviceTable = JSON.parse(JSON.stringify(deviceitemsByDate));
  DeviceTable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));
  if (!loadDevices || loading) return <LoadingComponent />;

  return (
    <>
      <div className="large-table-screen">
        <div className="small-table-screen">
          <Segment>
            <Header
              icon="list"
              size="huge"
              dividing
              as="h1"
              content="View Devices"
              sub
              color="grey"
            />
            {showText && (
              <DynamicTableFrontEnd
                data={DeviceTable}
                name={'DeviceTable'}
                actiontype={'editdel'}
              />
            )}
          </Segment>
        </div>
      </div>
    </>
  );
}
export default observer(DeviceMasterTable);
